import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { DEALATTRIBUTE_PERSONAL_URL } from './constants';

export default function useAttributes<T = any>(
  config?: SWRConfiguration,
): SWRResponse<T, Error> {
  return useSWR<T>(DEALATTRIBUTE_PERSONAL_URL, config);
}
